import { createSlice } from "@reduxjs/toolkit";

import {
  fileManagerReducer,
  getChildFoldersAction,
  renameFolderAction,
  uploadFileInDriveAction,
  initialState,
  createFolderAction,
  deleteFileAndFolderAction,
  getFileFolderAccessListAction,
  hideFileFolderAction,
  renameFileAction,
  updateFileFolderAccessAndPrivacyAction,
} from "@/redux/fileManager";
import type { FileManagerTypes } from "@/redux/fileManager/fileManagerTypes";

import type { FileFolderAccessListType } from "@/commonTypes/fileManagerTypes";

export const fileManagerSlice = createSlice({
  name: "fileManager",
  initialState,
  reducers: fileManagerReducer,

  extraReducers: (builder) => {
    builder.addCase(createFolderAction.pending, (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      createFolderAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
          };
        }

        return {
          ...state,
          fetching: false,
          success,
          statusCode: status_code,
        };
      }
    );

    builder.addCase(
      createFolderAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getChildFoldersAction.pending,
      (state: FileManagerTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getChildFoldersAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            fetching: false,
            error: message,
            statusCode: status_code,
            success,
          };
        }
        return {
          ...state,
          fetching: false,
          childFolders: result?.dir_list,
          childFolderCount: result?.dir_count,
          childFiles: result?.file_list,
          childFilesCount: result?.file_count,
          totalCount: result?.total_count,
          currentDirPath: result?.current_dir_path,
          isParrentHide: result?.is_hidden,
          currentFolderDetails: {
            id: result?.id,
            name: result?.name === "root" ? "Home" : result?.name,
            current_dir_path: result?.current_dir_path,
          },
        };
      }
    );

    builder.addCase(
      getChildFoldersAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      uploadFileInDriveAction.pending,
      (state: FileManagerTypes) => ({
        ...state,
        uploadFetching: true,
      })
    );

    builder.addCase(
      uploadFileInDriveAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, result, status_code } = payload;
        if (success === 0) {
          return {
            ...state,
            uploadFetching: false,
            error: message,
            statusCode: status_code,
            uploadSuccess: success,
            success: success,
            //  uploadFileData: result,
          };
        }

        return {
          ...state,
          uploadFetching: false,
          uploadSuccess: success,
          statusCode: status_code,
          uploadFileData: result,
          success: success,
        };
      }
    );

    builder.addCase(
      uploadFileInDriveAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        uploadFetching: false,
        uploadSuccess: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(renameFolderAction.pending, (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      renameFolderAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      renameFolderAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(renameFileAction.pending, (state: FileManagerTypes) => ({
      ...state,
      fetching: true,
    }));

    builder.addCase(
      renameFileAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      renameFileAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      deleteFileAndFolderAction.pending,
      (state: FileManagerTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      deleteFileAndFolderAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      deleteFileAndFolderAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      hideFileFolderAction.pending,
      (state: FileManagerTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      hideFileFolderAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, result, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
        };
      }
    );

    builder.addCase(
      hideFileFolderAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      updateFileFolderAccessAndPrivacyAction.pending,
      (state: FileManagerTypes) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateFileFolderAccessAndPrivacyAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, message, status_code } = payload;

        if (success === 0) {
          return {
            ...state,
            success,
            fetching: false,
            statusCode: status_code,
            error: message,
          };
        }

        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          privacyAccessUpdateMessage: message,
        };
      }
    );

    builder.addCase(
      updateFileFolderAccessAndPrivacyAction.rejected,
      (state: FileManagerTypes, { error }) => ({
        ...state,
        fetching: false,
        success: 0,
        error: error?.message ?? null,
      })
    );

    builder.addCase(
      getFileFolderAccessListAction.pending,
      (state: FileManagerTypes) => ({
        ...state,
        fileFolderAccessListFetching: true,
      })
    );

    builder.addCase(
      getFileFolderAccessListAction.fulfilled,
      (state: FileManagerTypes, { payload }) => {
        const { success, result } = payload;

        if (success === 0) {
          return {
            ...state,
            fileFolderAccessListFetching: false,
          };
        }

        return {
          ...state,
          fileFolderAccessListFetching: false,
          fileFolderAccessList: result as FileFolderAccessListType,
        };
      }
    );

    builder.addCase(
      getFileFolderAccessListAction.rejected,
      (state: FileManagerTypes) => ({
        ...state,
        fileFolderAccessListFetching: false,
      })
    );
  },
});

export const {
  resetFileManagerError,
  resetFileManagerSuccess,
  resetFileMangerFetching,
  resetFileManagerStatusCode,
  resetChildFoldersList,
  resetChildFilesList,
  resetCurrentDirPath,
  resetFileManagerUploadSuccess,
  resetUploadFileData,
  resetTotalCount,
  resetFileFolderAccessListFetching,
  resetFileFolderAccessList,
  resetPrivacyAccessUpdateMessage,
} = fileManagerSlice.actions;
